import ChatPopup, {ChatPopupProps} from '../ChatPopup';

interface ChatProps {
  useContext: () => ChatPopupProps;
}

export const Chat = ({useContext}: ChatProps) => {
  const context = useContext();
  return <ChatPopup {...context} />;
};